import { createContext } from "react";
const UniversalFormContext = createContext();
export default UniversalFormContext;
